import { render, staticRenderFns } from "./Level2-2.vue?vue&type=template&id=2968b060&scoped=true&"
import script from "./Level2-2.vue?vue&type=script&lang=js&"
export * from "./Level2-2.vue?vue&type=script&lang=js&"
import style0 from "./Level2-2.vue?vue&type=style&index=0&id=2968b060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968b060",
  null
  
)

export default component.exports